import { generateUniqueId } from '../../helpers/common';

export const GET_PORTFOLIO_FAULT_TOTALIZE_DATA = generateUniqueId();
export const GET_PORTFOLIO_FAULT_TOTALIZE_FAILURE = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_COMPANY = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_COMPANY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_COUNTRY = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_COUNTRY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_CITY = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_CITY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_PROJECT = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_PROJECT = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_DISPLAY_MODE = generateUniqueId();
export const RESET_SELECTED_PORTFOLIO_FAULT_DISPLAY_MODE = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_YEAR = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_YEAR = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_MONTH = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_MONTH = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_DAY = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_DAY = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_STATIONS = generateUniqueId();
export const UPDATE_SELECTED_PORTFOLIO_FAULT_STATIONS = generateUniqueId();
export const RESET_SELECTED_PORTFOLIO_FAULT_STATIONS = generateUniqueId();

export const SET_SELECTED_PORTFOLIO_FAULT_LEVEL = generateUniqueId();
export const RESET_SELECTED_PORTFOLIO_FAULT_LEVEL = generateUniqueId();

export const FETCH_PORTFOLIO_FAULT_LEVELS_REQUEST = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_LEVELS_SUCCESS = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_LEVELS_FAILURE = generateUniqueId();

export const GET_PORTFOLIO_FAULT_DETAILS_REQUEST = generateUniqueId();
export const GET_PORTFOLIO_FAULT_DETAILS_SUCCESS = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_DETAILS_FILTER = generateUniqueId();
export const UPDATE_PORTFOLIO_FAULT_DETAILS_FILTER = generateUniqueId();
export const GET_PORTFOLIO_FAULT_DETAILS_FAILURE = generateUniqueId();

export const FETCH_PORTFOLIO_FAULT_REQUEST = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_SUCCESS = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_FAILURE = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_DATA = generateUniqueId();

export const FETCH_PORTFOLIO_FAULT_LOG_REQUEST = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_LOG_SUCCESS = generateUniqueId();
export const FETCH_PORTFOLIO_FAULT_LOG_FAILURE = generateUniqueId();
export const RESET_PORTFOLIO_FAULT_LOG = generateUniqueId();